__turbopack_context__.v({
  "salesEndedMessage": "SalesEndedMessage-module-scss-module__HEJbdG__salesEndedMessage",
  "salesEndedMessageBody": "SalesEndedMessage-module-scss-module__HEJbdG__salesEndedMessageBody",
  "salesEndedMessageHeader": "SalesEndedMessage-module-scss-module__HEJbdG__salesEndedMessageHeader",
  "salesEndedMessageHeaderRow": "SalesEndedMessage-module-scss-module__HEJbdG__salesEndedMessageHeaderRow",
  "salesEndedMessageIcon": "SalesEndedMessage-module-scss-module__HEJbdG__salesEndedMessageIcon",
});
